/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pesticide_DosageInputs */

const vi_pesticide_dosage = /** @type {(inputs: Pesticide_DosageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liều lượng`)
};

/**

* @param {Pesticide_DosageInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pesticide_dosage = /** @type {((inputs?: Pesticide_DosageInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pesticide_DosageInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pesticide_dosage(inputs)
});